import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const ArrowButtonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M23.8 12.8L12.8.3c-.4-.4-1.1-.4-1.5 0L.3 12.8c-.4.4-.3 1 .1 1.4l1.9 1.6c.4.4 1.1.3 1.4-.1l8.2-9.5c.1-.1.2-.1.4 0l8.2 9.4c.2.2.4.3.7.3.3 0 .5-.1.7-.2l1.9-1.6c.3-.2.3-.9 0-1.3z"
    })
  });
};

export { ArrowButtonShape };
//# sourceMappingURL=ArrowButtonShape.js.map
